import * as React from "react";
import { Skeleton, SkeletonProps, useColorScheme } from "@mui/material";

export function CustomSkeleton({ ...props }: SkeletonProps) {
	const { colorScheme = "light" } = useColorScheme();

	return (
		<Skeleton
			{...props}
			sx={{ ...props.sx, backgroundColor: colorScheme === "light" ? "grey.100" : "var(--mui-palette-Skeleton-bg)" }}
		/>
	);
}
